import { __ } from '../../../locales'

const OuterWrapperFrameFilter = ({ inputs, onInputsChange}) => {
    const rand = Math.random()

    return (
        <div className={'input-component row'}>
            <input
                id={'outer-frame' + rand}
                type="checkbox"
                className="form-control"
                checked={inputs.outerFrame}
                onInput={(ev) => onInputsChange('outerFrame', ev.target.checked)}
            />
            <label for={'outer-frame' + rand}>{__('inputs.outer_border.label')}:</label>
        </div>
    );
};

export default OuterWrapperFrameFilter;
